module.exports = __webpack_public_path__ + "static/img/アセット 30@2x.2778aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 30@2x.png
// module id = kLGY
// module chunks = 1